import { NgDocCategory } from '@ng-doc/core';

const MThemeCategory: NgDocCategory = {
  title: 'Mtheme',
  order: 2,
};

export default MThemeCategory;
